import React, { createContext, useEffect, useState } from 'react';
import { client } from './prismic';


interface IPartnerElement {
  id: string;
  src: string;
  alt: string
  href: string;
}

interface IPartnerListElement {
  id: string;
  title: string;
  orderIndex: number;
  children: IPartnerElement[]
}



interface IAboutUsElement{
  supervisor: string;
  administrationPersons: string[];
  aboutUsParagraphs: string[];
  administrationTitle: string;
}

interface IPrismicContext {
  baseInformations: {
    mainImageSrc: string | null;
    title: string;
    subTitle: string;
    facebookLink: string;
    instagramLink: string;
    linkedinLink: string;
    tiktokLink: string;
    facebookLinkTop: string;
    instagramLinkTop: string;
    linkedinLinkTop: string;
  }
  aboutUs: IAboutUsElement
  partnersList: null | IPartnerListElement[]
}



const defaultContext: IPrismicContext = {
  baseInformations: {
    mainImageSrc: '',
    title: '',
    subTitle: '',
    facebookLink: '',
    instagramLink: '',
    linkedinLink: '',
    tiktokLink: '',
    facebookLinkTop: '',
    instagramLinkTop: '',
    linkedinLinkTop: ''
  },
  aboutUs: {
    supervisor: '',
    administrationPersons: [],
    aboutUsParagraphs: [],
    administrationTitle: ''
  },
  partnersList: null
}

export const PrismicContext = createContext<IPrismicContext>(defaultContext);

export const PrismicContextProvider = ({ children }: {
  children: React.ReactNode;
}) => {
  const [prismicContext, setPrismicContext] = useState(defaultContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const partnersList = await client.getAllByType("partners");
        const baseInformations = await client.getAllByType("base_information");
        const aboutUs = await client.getAllByType("about_us_page");


        const parsedPartnersList = partnersList.map(partnersListEl => {
          return {
            id: partnersListEl.id,
            title: partnersListEl.data.section_name[0].text,
            orderIndex: partnersListEl.data.order_index,
            children: partnersListEl.data.partners_group.map((partnerItemEl: any) => ({
              id: Math.random().toString(16).slice(2),
              src: partnerItemEl.partner_logo.url,
              alt: partnerItemEl.partner_name[0].text,
              href: partnerItemEl.partner_link.url
            }))
          }
        })

        parsedPartnersList.sort((a, b) => a.orderIndex - b.orderIndex)


        const parsedBaseInformations = {
          mainImageSrc: baseInformations[0].data.main_image.url,
          title: baseInformations[0].data.title[0].text,
          subTitle: baseInformations[0].data.sub_title[0].text,
          facebookLink: baseInformations[0].data.facebook_link.url,
          instagramLink: baseInformations[0].data.instagram_link.url,
          linkedinLink:baseInformations[0].data.linkedin_link.url,
          tiktokLink: baseInformations[0].data.tiktok_link.url,
          facebookLinkTop: baseInformations[0].data.facebook_link_top.url,
          instagramLinkTop: baseInformations[0].data.instagram_link_top.url,
          linkedinLinkTop: baseInformations[0].data.linkedin_link_top.url,
        }

        const aboutUsInformations = {
          supervisor: aboutUs[0].data.supervisor[0].text,
          administrationPersons: aboutUs[0].data.administration.map((item: any) => item.board_person[0].text),
          aboutUsParagraphs: aboutUs[0].data.about_us_desc.map((item: any) => item.text).filter((el: any) => el !== ""),
          administrationTitle: aboutUs[0].data.administration_title[0].text,
        }

        setPrismicContext({
          baseInformations: parsedBaseInformations,
          partnersList: parsedPartnersList,
          aboutUs: aboutUsInformations
        })

      } catch (error) {
        console.error("Błąd podczas pobierania danych z Prismic:", error);
      }
    };

    fetchData();
  }, []); //

  return(
    <PrismicContext.Provider value={prismicContext}>
      {children}
    </PrismicContext.Provider>
  )
}

